import type { ReactNode } from "react";
import { Popover, type PopoverProperties } from "@jetblue/kit/popover";
import { Button } from "react-aria-components";

import { ExpandableIndicator } from "../expandable-indicator";
import { cn } from "../../utilities/tailwind";

export type DropdownProperties = {
  /**
   * The content to be displayed inside the dropdown.
   */
  children: ReactNode;

  /**
   * Additional class names for the dropdown button.
   */
  className?: string | undefined;

  /**
   * Additional class names for the dropdown content area.
   */
  contentClassName?: string | undefined;

  /**
   * Disables the dropdown if set to true.
   */
  isDisabled?: boolean | undefined;

  /**
   * The label for the dropdown button.
   */
  label: string;
} & Omit<PopoverProperties, "triggerButton">;
export const Dropdown = ({
  children,
  className = "",
  contentClassName = "",
  isDisabled = false,
  label,
  ...properties
}: DropdownProperties) => {
  const twClassName = cn(
    "group/expandable-ui flex items-center gap-2 text-s-body-extra-bold! text-royal-blue focus-outline disabled:cursor-not-allowed disabled:opacity-50",
    className,
  );
  const twContentClassName = cn("rounded-t-none", contentClassName);

  return (
    <Popover
      dialogClassName={twContentClassName}
      offset={8}
      placement="bottom left"
      showOverlayArrow={false}
      {...properties}
      triggerButton={
        <Button className={twClassName} isDisabled={isDisabled}>
          {label}

          <ExpandableIndicator />
        </Button>
      }
    >
      {children}
    </Popover>
  );
};
Dropdown.displayName = "Dropdown";
